import MinimalNav from '@c/MinimalNav';
import Link from 'next/link';

interface VerifyEmailLayoutProps {
  children: React.ReactNode;
}

const MinimalLayout = ({ children }: VerifyEmailLayoutProps) => {
  return (
    <div className="relative flex min-h-screen flex-col items-center">
      <MinimalNav />
      <div className="relative grow self-stretch">{children}</div>
      <div className="flex h-[6.6rem] w-full max-w-[144rem] justify-between gap-[2.4rem] px-4 sm:px-default-padding-x">
        <p>© 2026 GearFocus</p>
        <div className="flex gap-[2.4rem]">
          <Link href="/contact">Contact</Link>
          <Link href="/policies/terms">Terms & Conditions</Link>
          <Link href="/policies/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default MinimalLayout;
